import { Subject } from 'rxjs';

export class Unsubscriber {
  private _done = new Subject<void>();
  public get done() {
    return this._done;
  }

  complete() {
    this.done.next();
    this.done.complete();
  }
}
